import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import ForgetPassword from './pages/ForgetPassword';
import RequestForgetPassword from './pages/RequestForgetPassword'
import ValidateOTP from './pages/ValidateOTP';

import NotFound from './pages/Page404';
import ComingSoon from './pages/ComingSoon';

import SoundBoxDashboard from './pages/SoundBoxDashboard';
import SoundBoxControlCenter from './pages/SoundBoxControlCenter';
import SoundBoxDevices from './pages/SoundBoxDevices';
import SoundBoxDeviceDetails from './pages/SoundBoxDeviceDetails';
import Organizations from './pages/Organizations';
import OrganizationUsers from './pages/OrganizationUsers';
import MerchantListAudioCube from './pages/MerchnatsAudioCube';
import MerchantListForSupport from './pages/MechantListForSupport'
 


import { useAuth } from './components/customContextProviders/AuthContext';
import {encryptStorage} from './CustomStorage';


const isAuthenticated= encryptStorage.getItem('isLoggedin');

export const useAuthCheck = () => {
  const {sessionUserData}  = useAuth();

  return {
    isAuthenticated: !!sessionUserData,
    sessionUserData,
  };
};


// ----------------------------------------------------------------------

export default function Router() {

  const { isAuthenticated } = useAuthCheck();

  return useRoutes([
    {
      path: '/dashboard',
      element: isAuthenticated ? <DashboardLayout/> : <Navigate to="/login" replace /> ,
      children: [
        { element: <Navigate to="/dashboard/soundboxT" replace /> },    
        {path:'soundboxdevices',element:<SoundBoxDevices/>}, 
        {path:'soundboxT',element:<SoundBoxDashboard/>},
        {path:'soundboxcontrolcenter',element:<SoundBoxControlCenter/>},
        {path:'soundboxdevicedetails',element:<SoundBoxDeviceDetails/>},
        {path:'organizations',element:<Organizations/>},
        {path:'organizationusers',element:<OrganizationUsers/>},
        {path:'merchants',element:<MerchantListAudioCube/>}, 
        {path:'merchantlistforsupport',element:<MerchantListForSupport/>}, 
     
      ]
    },
  
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> :  <Login />  },
        // { path: 'register', element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> : <Register /> },
        { path: 'resetpassword/:token', element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> : <ForgetPassword /> },
        { path: 'forgetpassword', element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> : <RequestForgetPassword /> },
        { path: 'validateotp', element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> :  <ValidateOTP />  },



        { path: '404', element: <NotFound /> },
        { path: 'comingsoon', element: <ComingSoon /> },
       

        { path: '/', element:  isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> : <Navigate to="/login" replace /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
